import type { LayoutVariables } from '../types';
import { ReactComponent as Logo } from '../assets/images/uncinc-logo.svg';

const layoutVariables: LayoutVariables = {
  logo: {
    LogoSVG: Logo,
  },
  basicPage: {
    breadcrumbsColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    heroTextColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  homePage: {
    heroImageRatioXS: '4_3',
    heroImageRatioSM: '4_3',
    heroImageRatioMD: '2_1',
    heroImageRatioLG: '3_1',
    heroImageRatioXL: '3_1',
    heroTextColClasses: 'col-12 col-md-6 offset-lg-1',
    heroButtonColClasses: 'col-12 col-md-6',
    heroQuicklinksColClasses: 'col-12 col-md-5 offset-md-1 col-lg-4 offset-lg-0 col-xl-3 offset-xl-1',
    quickLinksButtonType: 'textual',
  },
  landingPage: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '16_9',
    heroImageRatioMD: '16_9',
    heroImageRatioLG: '16_9',
    heroImageRatioXL: '16_9',
    heroTextColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    heroImageColClasses: 'col-full col-md-12',
  },
  overviewPage: {
    breadcrumbsColClasses: 'col-12 col-md-10 col-lg-9',
    heroTextColClasses: 'col-12 col-md-10 col-lg-9',
  },
  profilePage: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '1_1',
    heroImageRatioXL: '1_1',
    breadcrumbsColClasses: 'col-12',
    heroImageColClasses: 'col-6 col-md-5 col-lg-4',
    heroDetailsColClasses: 'col-12 col-md-7 col-lg-6 offset-lg-1',
    bodyBelowHero: false,
    heroBodyColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2', // only used if bodyBelowHero is true
  },
  profileTeaser: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '1_1',
    heroImageRatioXL: '1_1',
  },
  article: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '1_1',
    heroImageRatioXL: '1_1',
    breadcrumbsColClasses: 'col-12 col-lg-10 offset-lg-1',
    heroTextColClasses: 'col-12 col-md-6 col-lg-4 offset-lg-1',
    heroImageColClasses: 'col-12 col-md-5 offset-md-1',
  },
  articleTeaser: {
    heroImageRatioXS: '4_3',
    heroImageRatioSM: '4_3',
    heroImageRatioMD: '4_3',
    heroImageRatioLG: '4_3',
    heroImageRatioXL: '4_3',
  },
  project: {
    heroImageRatioXS: '16_9',
    heroImageRatioSM: '16_9',
    heroImageRatioMD: '16_9',
    heroImageRatioLG: '16_9',
    heroImageRatioXL: '16_9',
    breadcrumbsColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    heroTextColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    heroImageColClasses: 'col-full col-md-12 col-lg-10 offset-lg-1',
  },
  projectTeaser: {
    heroImageRatioXS: '4_3',
    heroImageRatioSM: '4_3',
    heroImageRatioMD: '4_3',
    heroImageRatioLG: '4_3',
    heroImageRatioXL: '4_3',
  },
  themeParent: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '2_1',
    heroImageRatioLG: '2_1',
    heroImageRatioXL: '2_1',
    heroTextColClasses: 'col-8 offset-2 col-lg-6 offset-lg-3',
    heroMediaColClasses: 'col-full',
    textColClasses: 'col-12 col-lg-8 offset-lg-2',
    searchThemesColClasses: 'col-12 col-lg-8 offset-lg-2',
  },
  themeChild: {
    heroImageRatioXS: '16_9',
    heroImageRatioSM: '16_9',
    heroImageRatioMD: '16_9',
    heroImageRatioLG: '16_9',
    heroImageRatioXL: '16_9',
    heroTextColClasses: 'col-12 col-lg-8 offset-lg-2',
    heroMediaColClasses: 'col-12',
    textColClasses: 'col-12 col-lg-8 offset-lg-2',
    searchThemesColClasses: 'col-12 col-lg-8 offset-lg-2',
  },
  paragraphHtmlEmbed: {
    contentColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  paragraphLinkList: {
    imageRatio: '1_1',
    bodyColClasses: 'col-12 col-lg-6',
    linksColClasses: 'col-12 col-lg-6',
  },
  paragraphMetrics: {
    paragraphSingle: 'col-12 col-lg-8 offset-lg-2',
    paragraphMultiple: 'col-12',
    headerSingle: 'col-12 col-lg-8 offset-lg-2',
    headerMultiple: 'col-12 col-lg-8 offset-lg-2',
  },
  paragraphTextMedia: {
    forceTopAlignmentVideoAudio: false,
    alignmentTopImageRatioXS: '16_9',
    alignmentTopImageRatioSM: '16_9',
    alignmentTopImageRatioMD: '16_9',
    alignmentTopImageRatioLG: '16_9',
    alignmentTopImageRatioXL: '16_9',
    alignmentLeftRightImageRatioXS: '16_9',
    alignmentLeftRightImageRatioSM: '16_9',
    alignmentLeftRightImageRatioMD: '16_9',
    alignmentLeftRightImageRatioLG: '16_9',
    alignmentLeftRightImageRatioXL: '16_9',
    mediaColClasses: 'col-12 col-md-6 col-lg-5',
    mediaColClassesAlignmentRight: 'offset-lg-1',
    mediaColClassesAlignmentTop: 'col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    textColClasses: 'col-12 col-md-6 col-lg-5',
    textColClassesAlignmentLeft: 'offset-lg-1',
    textColClassesAlignmentTop: 'col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  paragraphQuote: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '1_1',
    heroImageRatioXL: '1_1',
    imageColClasses: 'col-12 col-md-6 col-lg-5',
    imageColClassesAlignmentRight: 'offset-lg-1',
    textColClassesWithImage: 'col-12 col-md-6',
    textColClassesWithImageAlignmentLeft: 'offset-lg-1',
    textColClassesWithoutImage: 'col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  paragraphFAQ: {
    textColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    textColClassesHorizontal: 'col-12 col-md-10 offset-md-1 col-lg-4 offset-lg-0',
    faqColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    faqColClassesHorizontal: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-0',
  },
  paragraphWebform: {
    textColClasses: 'col-12 col-lg-10 offset-lg-1',
    webformColClasses: 'col-12 col-lg-10 offset-lg-1',
  },
  blockCTA: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '1_1',
    heroImageRatioXL: '1_1',
    backgroundImageRatio: '3_2',
    imageColClasses: 'col-12 col-md-4 col-lg-3 offset-lg-1',
    textColClasses: 'col-12 col-md-8 col-lg-7',
    backgroundTextColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  searchPage: {
    hitsPerPage: 20,
    textColClasses: 'col-12 col-lg-9',
    facetColClasses: 'col-12 col-lg-4',
    resultsColClasses: 'col-12 col-lg-8',
  },
  footer: {
    footerLogoColClasses: 'col-12',
    footerMainSectionColClasses: 'col-12 col-lg-9',
    footerContactBlockColClasses: 'col-12 col-lg-3',
  },
};

export default layoutVariables;
